import { Tranche } from '../../gameday/data/gameDay-data.transformations';
import { GameDayViewType } from '../../state/data/state';
import { orderIsRetailType } from '../../gameday/data/gameDay-data-orders.calculation';

/**
 * Returns tranche for every gameday view type except retail,
 * where it returns tranche with filtered tranche orders by retail type.
 * Retail type in this case should be (full or low) priority.
 *
 * @param  tranche
 * @param  viewType
 * @returns Tranche
 */
export function trancheDetailsMapper(
  tranche: Tranche,
  viewType: GameDayViewType
): Tranche {
  if (viewType === GameDayViewType.RetailType) {
    return {
      ...tranche,
      orders: tranche.orders.filter(orderIsRetailType)
    };
  }

  return {
    ...tranche,
    orders: tranche.orders.slice()
  };
}
